/* eslint-disable react/require-default-props */
import React from 'react';
import { Field } from 'react-final-form';
import { RenderDropdown } from 'forms';

import { justificationOptions } from './constants';

interface Props {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
    disabled?: boolean;
}

export default function FertilizerEventJustificationDropdown(
    props: Props
): React.ReactElement {
    const {
        name,
        label,
        validate,
        nullOnUnmount = false,
        placeholder,
        disabled = false
    } = props;

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label={label || 'Justification option'}
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={justificationOptions}
            nullOnUnmount={nullOnUnmount}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
}
